import React from "react";

const GoogleInfo = () => {
  return (
    <div className="settings-section google-info">
      <h2>🔐 Google Account</h2>
      <p>
        You're signed in with Google. Password management is handled by your
        Google account.
      </p>
    </div>
  );
};

export default GoogleInfo;
